import { AgentPageModel } from "../models/agent.model"

export const agentData: AgentPageModel =
{
  name: 'Ronaldo Alves',
  email: 'ronaldo@email.com',
  phone: '+351 960 000 000',
  address: 'Porto, Paranhos',
  designation: 'Gestor de Vendas',
  description: 'É com grande satisfação que apresentamos Ronaldo Alves, nosso estimado Gestor de Vendas de Imóveis na AGII. Com uma carreira marcada por um compromisso inabalável com a excelência e um profundo conhecimento do mercado imobiliário, Ronaldo tem sido um pilar fundamental em nossa equipe. <br><br>Ronaldo Alves possui uma vasta experiência no setor imobiliário, acumulando mais de 15 anos de atuação dedicada e bem-sucedida. Sua trajetória é marcada por uma combinação única de habilidades estratégicas, visão de mercado e um excepcional talento para construir relacionamentos sólidos e duradouros com clientes e parceiros.<br><br> Na AGII, Ronaldo lidera a equipe de vendas com uma abordagem inovadora e focada em resultados. Sua capacidade de entender as necessidades individuais de cada cliente e oferecer soluções personalizadas tem sido crucial para o nosso crescimento e sucesso contínuo. Ronaldo acredita firmemente que a chave para um bom negócio é a confiança mútua e a transparência, valores que ele pratica e promove em todas as suas interações.',
  image: 'assets/images/user/avatar-3.jpg',
  languages: ['Inglês', 'Português', 'Alemão'],
  latitude: 41.1753831,
  longitude: -8.6178167,
  socialMedia: [
    { name: 'Facebook', color: '#3b5998', icon: 'fa-facebook', link: 'https://facebook.com' },
    { name: 'Linkedin', color: '#0077b5', icon: 'fa-linkedin', link: 'https://linkedin.com' },
  ],
  properties: [
    {
      address: "Rua de Teste",
      businessStatus: "Novidade",
      businessType: "Para Arrendamento",
      cardToShow: "Novidade",
      county: "Braga",
      district: "Braga",
      media: [{ file: 'https://admin-api.imodigi.com/properties/image/1014017165427886932e56bcd6c0ad41aa92fbad6de0742df3' }],
      highlight: true,
      price: "700",
      reference: "aaew23",
      title: "Apartamento em Braga",
      uniqueId: "15-13-aaew23"
    },
    {
      address: "Rua de Teste",
      businessStatus: "Novidade",
      businessType: "Para Venda",
      cardToShow: "Novidade",
      county: "Paranhos",
      district: "Porto",
      media: [{ file: 'https://admin-api.imodigi.com/properties/image/101391716542657092c2155d6d0a49473d881174a368bda28f' }],
      highlight: true,
      price: "200000",
      reference: "aaew23",
      title: "Apartamento em Paranhos",
      uniqueId: "15-13-aaew23"
    }
  ]
}



export const agentsData = [
  { id: 1, name: 'Ronaldo Alves', email: 'ronaldo@email.com', address: 'Porto, Paranhos', designation: 'Gestor de Vendas', image: 'assets/images/user/avatar-3.jpg' },
  { id: 2, name: 'Ricardo Santos', email: 'ricardo@email.com', address: 'Lisboa, Benfica', designation: 'Gestor de Vendas', image: 'assets/images/user/avatar-7.jpg' },
  { id: 3, name: 'Joana Carvalho', email: 'joana@email.com', address: 'Porto, Braga', designation: 'Gestora de Vendas', image: 'assets/images/user/avatar-4.jpg' },
  { id: 4, name: 'Maria Joana', email: 'maria@email.com', address: 'Lisboa, Cascais', designation: 'Gestora de Imóveis', image: 'assets/images/user/avatar-5.jpg' },
  { id: 5, name: 'Cristiano Soares', email: 'cristiano@email.com', address: 'Porto, Matosinhos', designation: 'Consultor Imobiliário', image: 'assets/images/user/avatar-8.jpg' },
  { id: 6, name: 'Joaquim Manoel', email: 'joaquim@email.com', address: 'Guimarães', designation: 'Gestor de Imóveis', image: 'assets/images/user/avatar-9.jpg' },
]


export const agentsLocationData = [
  { id: 1, name: 'Ronaldo Alves', latitude: 41.1647123, longitude: -8.6076719, email: 'ronaldo@email.com', address: 'Porto, Paranhos', designation: 'Gestor de Vendas', image: 'assets/images/user/avatar-3.jpg' },
  { id: 2, name: 'Ricardo Santos', latitude: 41.1842271, longitude: -8.6851725, email: 'ricardo@email.com', address: 'Lisboa, Benfica', designation: 'Gestor de Vendas', image: 'assets/images/user/avatar-7.jpg' },
  { id: 3, name: 'Joana Carvalho', latitude: 41.5480438, longitude: -8.4234165, email: 'joana@email.com', address: 'Braga', designation: 'Gestora de Vendas', image: 'assets/images/user/avatar-4.jpg' },
  { id: 4, name: 'Maria Joana', latitude: 38.7089384, longitude: -9.4432262, email: 'maria@email.com', address: 'Lisboa, Cascais', designation: 'Gestora de Imóveis', image: 'assets/images/user/avatar-5.jpg' },
  { id: 5, name: 'Cristiano Soares', latitude: 41.1842271, longitude: -8.6851725, email: 'cristiano@email.com', address: 'Porto, Matosinhos', designation: 'Consultor Imobiliário', image: 'assets/images/user/avatar-8.jpg' },
  { id: 6, name: 'Joaquim Manoel', latitude: 41.4439085, longitude: -8.2976157, email: 'joaquim@email.com', address: 'Guimarães', designation: 'Gestor de Imóveis', image: 'assets/images/user/avatar-9.jpg' },
]
